// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const preciosEnvioPiezasFullfilledReducer = makeSetReducer(['precios_envio_piezas/fullfilled']);
